import { useCallback } from 'react';
import { loadScript } from '../../../utils/tracking/googleAnalyticsTracking';
import useLoadTracking from '../../../utils/tracking/useLoadTracking';

/* Because the CDN caches the server rendered page, and the cookies are specific to each client,
 * this only runs in the client
 */
const CookieConsent = () => {
  const loadGoogleAnalytics = useCallback(() => {
    loadScript();
  }, []);

  useLoadTracking(loadGoogleAnalytics);

  // For now only run GA in consent mode,
  // We will redesign a new cookie banner for getting consent
  return null;
};

export default CookieConsent;
